import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tracking } from '../../models/tracking';
import { CrudService } from '../crud.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingApiService extends CrudService<Tracking> {
  protected basePath = 'tracking';
  public instanceType = 'tracking';

  constructor(http: HttpClient) {
    super(http);
  }
}
